import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { on as u, off as S } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { computed as p, onUnmounted as $ } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const R = "n-draggable";
function U(g, A) {
  let i;
  const M = p(() => g.value !== !1), h = p(() => M.value ? R : ""), C = p(() => {
    const e = g.value;
    return e === !0 || e === !1 ? !0 : e ? e.bounds !== "none" : !0;
  });
  function E(e) {
    const l = e.querySelector(`.${R}`);
    if (!l || !h.value)
      return;
    let s = 0, f = 0, c = 0, d = 0, X = 0, Y = 0, r;
    function b(t) {
      t.preventDefault(), r = t;
      const {
        x: a,
        y: w,
        right: n,
        bottom: o
      } = e.getBoundingClientRect();
      f = a, d = w, s = window.innerWidth - n, c = window.innerHeight - o;
      const {
        left: m,
        top: v
      } = e.style;
      X = +v.slice(0, -2), Y = +m.slice(0, -2);
    }
    function y(t) {
      if (!r)
        return;
      const {
        clientX: a,
        clientY: w
      } = r;
      let n = t.clientX - a, o = t.clientY - w;
      C.value && (n > s ? n = s : -n > f && (n = -f), o > c ? o = c : -o > d && (o = -d));
      const m = n + Y, v = o + X;
      e.style.top = `${v}px`, e.style.left = `${m}px`;
    }
    function D() {
      r = void 0, A.onEnd(e);
    }
    u("mousedown", l, b), u("mousemove", window, y), u("mouseup", window, D), i = () => {
      S("mousedown", l, b), u("mousemove", window, y), u("mouseup", window, D);
    };
  }
  function x() {
    i && (i(), i = void 0);
  }
  return $(x), {
    stopDrag: x,
    startDrag: E,
    draggableRef: M,
    draggableClassRef: h
  };
}
export {
  R as DRAGGABLE_CLASS,
  U as useDragModal
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/composables.js
// module id = 924
// module chunks = 41